module.exports = __webpack_public_path__ + "static/media/prankdial@3x.c4091424.png";